<template>
    <div class="select-area"  @click="showOption()">
        <div class="show-view">
            <div class="select">
                <div class="select-show" :class="{input: hasInput||showText=='中国大陆'}">{{showText}}</div>
            </div>
            <span class="select-icon"><img class="icon-img" :src="arrowSrc"></span>
        </div>
        <div class="dropDown">
          <ul class="select-option">
            <li class="option-item" v-for="option in options" :class="{selected: selectOption.name == option.name || selectedValue==option.name }"
                @click="updateValue(option) ">{{option.name}}
            </li>
        </ul>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        name: 'SelectField',
        props: [ 'value', 'placeholder','options','selectedValue'],
        data() {
            return {
                arrowSrc:/Android|webOS|iPhone|iPod|BlackBerry|ios|iPad/i.test(navigator.userAgent)?require('../assets/img/arrow-wap.png'):require('../assets/img/arrow-icon.png'),
                isWhite: false,
                selectOption:{},
                hasInput:false,
                showText:(this.selectedValue ? this.selectedValue:this.placeholder )|| this.placeholder || ''
            }
        },
        watch:{
            value(val){
                this.showText = (val ? val : this.placeholder) || this.placeholder || '';
                this.hasInput=(val  ? val :this.placeholder)
            }
        },
        methods: {
            updateValue(option) {
                console.log(option);
                var val = option.name;
                this.$emit('input', val)
                this.$emit('changeSelected', option)
                this.selectOption = option
                this.showText = option.name
                this.hasInput = true;
            },
            showOption() {
                $(this.$el).parent().siblings().find('.dropDown').hide();
                $(this.$el.children[1]).toggle();
            }
        }
    }
</script>
<style lang="scss">
    .select-area {
        position: relative;
        width:456px;
        height:50px;
        line-height:50px;
        font-size:14px;
        color:#bcbcbc;
        .show-view {
            width: 100%;
            position: relative;
            display: flex;
            z-index: 112;
            .select-title {
                height:50px;
                padding-left:15px;
                flex-shrink: 0;
                z-index: 112;
                span{
                   color:#ff4301;
                }
            }
            .select {
                height:50px;
                position: relative;
                background:#fff;
                border:1px solid #eaeaea;
                flex-grow: 1;
                border-radius:2px;
                .select-show {
                    height:50px;
                    padding-left:15px;
                    line-height: 50px;
                    text-align:left;
                    font-size: 14px;
                    color: #bcbcbc;
                    overflow: hidden;
                    &.input {
                        color:#282828;
                    }
                }
            }
            .select-icon {
                position:absolute;
                top:3px;
                right:20px;
                width: 9px;
                height:50px;
                flex-shrink: 0;
                .icon-img {
                    width: 9px;
                    height: 15px
                }
            }
        }
        .dropDown{
            display:none;
            height: 248px;
        }
        .select-option {
            position: absolute;
            top:50px;
            z-index: 1111;
            width: 100%;
            max-height:251px;
            overflow: auto;
            background: #ffffff;
            overflow-x: hidden;
            border: solid 1px #eaeaea;
            border-top:0px;
            border-radius: 0 0 2px 2px;
            /*滚动条样式*/
            &::-webkit-scrollbar {
                width: 3px;
            }
            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background: #cecece;
            }
            &::-webkit-scrollbar-track {
                border-radius: 0;
                background: #f1f1f1;

            }
            &.show {
                display: block;
            }
            .option-item {
                overflow: hidden;
                height: 50px;
                line-height: 50px;
                text-align: center;
                z-index: 1113;
                border-bottom:1px solid #f4f4f4;
                cursor:pointer;
                &:last-child{border-bottom:0px;}
                &:first-child{border-top:0px;}
                &.selected {
                    background: #eeeeee;
                    color: #e8202f;
                    font-weight:700;
                }

            }

        }
    }
    @media (max-width:718px){
        .select-area {
            width:456px;
            height:0.82rem;
            line-height:0.82rem;
            font-size:0.22rem;
            .show-view {
                width: 100%;
                .select-title {
                    height:0.82rem;
                    padding-left:0.3rem;
                    span{
                        color:#ff4301;
                    }
                }
                .select {
                    height:0.82rem;
                    .select-show {
                        height:0.82rem;
                        padding-left:0.3rem;
                        line-height: 0.82rem;
                        font-size: 0.22rem;
                    }
                }
                .select-icon {
                    top: 0.04rem;
                    right: 0.3rem;
                    width: 0.12rem;
                    height:0.82rem;
                    .icon-img {
                        width: 0.12rem;
                        height: 0.2rem;
                    }
                }
            }
            .dropDown{
                max-height: 4.1rem;
            }
            .select-option {
                top:0.82rem;
                width: 100%;
                /*滚动条样式*/
                &::-webkit-scrollbar {
                    width: 0.03rem;
                }

                .option-item {
                    overflow: hidden;
                    height: 0.82rem;
                    line-height: 0.82rem;
                }

            }
        }
    }
</style>
